@if (!column.renderer) {
  <div>
    @switch (column.dataType) {
      @case ('decimal') {
        <div style="text-align: right;">{{columnContent}} </div>
      }
      @case ('number') {
        <div style="text-align: right;">{{columnContent | number:(column.format || '1.0-3')}}</div>
      }
      @case ('date') {
        <div style="text-align: right;">{{columnContent | date:(column.format || 'dd.MM.yyyy')}}</div>
      }
      @case ('time') {
        <div style="text-align: right;">{{columnContent | date:(column.format || 'HH:mm')}} </div>
      }
      <!-- this is the only switch case used so far -->
      @default {
        <div class="defaultActionContainer">
          @if (defaultAction && isDefaultColumn) {
            <ng-container *ngTemplateOutlet="defaultAction; context:{index: ri, row: row}"></ng-container>
          } @else if (defaultActionRoute && isDefaultColumn) {
            <a
              [class.disabledLink]="disableDefaultActionLink"
              (click)="onBeforeNavigateDefaultRoute()"
              [routerLink]="defaultActionRoute.replace(':id', rowId)"
              [queryParams]="defaultActionRouteQueryParams ? defaultActionRouteQueryParams : {showBackButton: showBackButton}"
              class="defaultActionLink"
              [title]="getDefaultActionToolTipForColumn(columnContent)">{{columnContent}}</a>
          } @else if (defaultActionUrl && isDefaultColumn) {
            <a
              [class.disabledLink]="defaultActionRowRight ? !row.get(defaultActionRowRight) : false"
              [href]="defaultActionUrl.replace(':id', rowId)"
              target="_blank"
              class="defaultActionLink"
              [title]="getDefaultActionToolTipForColumn(columnContent)">{{columnContent}}</a>
          } @else {
            {{ columnContent === '1' && column.format==='Boolean' ? ( 'de.his.javang.ja.lowercase' | hisUi )
            : columnContent === '0' && column.format==='Boolean'? ( 'de.his.javang.nein.lowercase' | hisUi )
            : columnContent }}
          }
        </div>
      }
    }
  </div>
} @else {
  <div [innerHTML]="column.renderer(this, ri, row) | hisHtmlUnsafe"></div>
}
